class Tools {
    constructor() {
        this.r = null;
        this.i = 0;
    };

    teste = () => {
        return 'Hello!';
    };

    newGuid = () => {
        this.i = 0;
        this.r = new Uint8Array(32);
        window.crypto.getRandomValues(this.r);
        return this.b();
    };

    b = (a) => {
        return a ? (((a ^ this.r[this.i++]) % 16) >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, this.b);
    };

    fancyTimeFormat = (seconds) => {
        let d = Number(seconds);
        let h = Math.floor(d / 3600);
        let m = Math.floor(d % 3600 / 60);
        let s = Math.floor(d % 3600 % 60);
        return h + ":" + m.toString().padStart(2, "0") + ":" + s.toString().padStart(2, "0");
    };

    dateFormat = (date, zone) => {
        let ret = "";
        if (zone === 'en-US') {
            let hora = (date.getHours() > 12 ? date.getHours() - 12 : date.getHours());
            let t = (date.getHours() > 12 ? ' PM' : ' AM');
            ret = (date.getMonth() + 1) + "." + date.getDate() + "." + date.getFullYear() + " " + ("00" + hora).slice(-2) + ":" + ("00" + date.getMinutes()).slice(-2) + t;
        } else {
            ret = ("00" + date.getDate()).slice(-2) + "." + ("00" + (date.getMonth() + 1)).slice(-2) + "." + date.getFullYear() + " " + ("00" + date.getHours()).slice(-2) + ":" + ("00" + date.getMinutes()).slice(-2);
        }
        return ret;
    };

    dateFormatWithSeconds = (date, zone) => {
        let ret = "";
        if (zone === 'en-US') {
            let hora = (date.getHours() > 12 ? date.getHours() - 12 : date.getHours());
            let t = (date.getHours() > 12 ? ' PM' : ' AM');
            ret = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear() + " " + ("00" + hora).slice(-2) + ":" + ("00" + date.getMinutes()).slice(-2) + ":" + ("00" + date.getSeconds()).slice(-2) + t;
        } else {
            ret = ("00" + date.getDate()).slice(-2) + "/" + ("00" + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear() + " " + ("00" + date.getHours()).slice(-2) + ":" + ("00" + date.getMinutes()).slice(-2) + ":" + ("00" + date.getSeconds()).slice(-2);
        }
        return ret;
    };

    formatHec = (hec) => {
        return ((hec) / 10000).toFixed(3);
    };

    formatDate = (date) => {
        return (date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear());
    };

    formatDateTime = (date) => {
        return (date.getDate() + '/' + ("00" + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear()) + " " + ("00" + date.getHours()).slice(-2) + ":" + ("00" + date.getMinutes()).slice(-2);
    };

    dateTimeZoneFormat = (date, format, timezone) => {
        const value = date instanceof Date ? new Date(date.getTime()) : new Date(date);

        if (isNaN(value.getTime())) {
            return 'Invalid date';
        }

        const date_timezone = timezone ? timezone : 'America/Sao_Paulo';
        
        let dateParts;

        try {
            dateParts = new Intl.DateTimeFormat('en-US', {
                timeZone: date_timezone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hourCycle: 'h23'
            }).formatToParts(value).reduce((parts, part) => {
                if (part.type !== 'literal') {
                    parts[part.type] = part.value;
                }
                return parts;
            }, {});
        } catch (error) {
            return 'Invalid timezone';
        }

        const year = Number(dateParts.year);
        const month = Number(dateParts.month);
        const day = Number(dateParts.day);
        const hour = Number(dateParts.hour) % 24;
        const minute = Number(dateParts.minute);
        const second = Number(dateParts.second);
        const hour12 = hour % 12 || 12;
        const milliseconds = value.getUTCMilliseconds();
        const zonedTime = Date.UTC(year, month - 1, day, hour, minute, second);
        const timestampWithoutMilliseconds = Math.floor(value.getTime() / 1000) * 1000;
        const offsetMinutes = Math.round((zonedTime - timestampWithoutMilliseconds) / 60000);
        const offsetSign = offsetMinutes >= 0 ? '+' : '-';
        const absoluteOffset = Math.abs(offsetMinutes);
        const offsetHours = Math.floor(absoluteOffset / 60).toString().padStart(2, '0');
        const offsetMinutePart = (absoluteOffset % 60).toString().padStart(2, '0');
        const weekDate = new Date(Date.UTC(year, month - 1, day));
        const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const monthNamesShort = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        const weekdayNames = [
            'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
        ];
        const weekdayNamesShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const weekday = weekDate.getUTCDay();

        const tokens = {
            YYYY: year.toString().padStart(4, '0'),
            YY: year.toString().slice(-2),
            MMMM: monthNames[month - 1],
            MMM: monthNamesShort[month - 1],
            MM: month.toString().padStart(2, '0'),
            M: month.toString(),
            DD: day.toString().padStart(2, '0'),
            D: day.toString(),
            dddd: weekdayNames[weekday],
            ddd: weekdayNamesShort[weekday],
            HH: hour.toString().padStart(2, '0'),
            H: hour.toString(),
            hh: hour12.toString().padStart(2, '0'),
            h: hour12.toString(),
            mm: minute.toString().padStart(2, '0'),
            m: minute.toString(),
            ss: second.toString().padStart(2, '0'),
            s: second.toString(),
            SSS: milliseconds.toString().padStart(3, '0'),
            A: hour < 12 ? 'AM' : 'PM',
            a: hour < 12 ? 'am' : 'pm',
            Z: offsetSign + offsetHours + ':' + offsetMinutePart,
            ZZ: offsetSign + offsetHours + offsetMinutePart
        };

        const dateFormat = format || 'YYYY-MM-DDTHH:mm:ssZ';
        const tokenPattern = /(\[[^\]]*\])|YYYY|MMMM|dddd|MMM|ddd|SSS|YY|MM|DD|HH|hh|mm|ss|ZZ|M|D|H|h|m|s|A|a|Z/g;

        return dateFormat.replace(tokenPattern, token => {
            if (token[0] === '[' && token[token.length - 1] === ']') {
                return token.slice(1, -1);
            }
            return tokens[token];
        });
    };

    cssShow = (col, show) => {
        let cols = document.getElementsByClassName(col);
        for (let i = 0; i < cols.length; i++) {
            cols[i].style.display = show ? 'block' : 'none';
        }
    };

    getDateToInputDate = (value) => {
        let date = this.adjustForTimezone(new Date(value));
        let ret = date.getFullYear() + '-';
        ret += (date.getMonth() + 1).toString().padStart(2, '0') + '-';
        ret += date.getDate().toString().padStart(2, '0');
        return ret;
    };

    adjustForTimezone = (date) => {
        const timeOffsetInMS = date.getTimezoneOffset() * 60000;
        date.setTime(date.getTime() + timeOffsetInMS);
        return date
    };

    replaceString = (base, ...strings) => {
        if (!base) return null;

        const regex = /:\?/g;
        const placeholders = (base.match(regex) || []).length;
        if (placeholders !== strings.length) {
            return null;
        }

        let index = 0;
        return base.replace(regex, () => strings[index++]);
    };
    mps_to_kmh = (value) => {// 1m/s = 3.6 km/h
        if (!isNaN(value)) {
            return value * 3.6;
        } else {
            return 0;
        }
    };
    kmh_to_mph = (value) => {// 1km/h = 0.621371 mph
        if (!isNaN(value)) {
            return value / 1.60934;
        } else {
            return 0;
        }
    }
    mps_to_mph = (value) => {// 1m/s = 2.23694 mph
        if (!isNaN(value)) {
            return value * 2.23694;
        } else {
            return 0;
        }
    };
    l_to_gal = (value) => {// 1L = 0.264172 gal
        if (!isNaN(value)) {
            return value / 3.78541;
        } else {
            return 0;
        }
    }
    gal_to_l = (value) => {// 1gal = 3.78541 L
        if (!isNaN(value)) {
            return value * 3.78541;
        } else {
            return 0;
        }
    }
    m_to_ft = (value) => {// 1m = 3.28084 ft
        if (!isNaN(value)) {
            return value * 3.28084;
        } else {
            return 0;
        }
    }
    ft_to_m = (value) => {// 1ft = 0.3048 m
        if (!isNaN(value)) {
            return value / 3.28084;
        } else {
            return 0;
        }
    }
    m_to_in = (value) => {// 1m = 39.3701 inch
        if (!isNaN(value)) {
            return value * 39.3701;
        } else {
            return 0;
        }
    }
    m_to_yard = (value) => {// 1m = 1.09361 yard
        if (!isNaN(value)) {
            return value * 1.09361;
        } else {
            return 0;
        }
    }
    km_to_m = (value) => {// 1km = 0.621371 mile
        if (!isNaN(value)) {
            return value / 1.60934;
        } else {
            return 0;
        }
    }
    ha_to_ac = (value) => {// 1ha = 2.47105 acre
        if (!isNaN(value)) {
            return value * 2.47105;
        } else {
            return 0;
        }
    }
    lpha_to_gpac = (value) => {// 1L/ha = 0,106907 gal/ac
        if (!isNaN(value)) {
            return value / 9.354
        } else {
            return 0;
        }
    }
    gpac_to_lpha = (value) => {// 1gal/ac = 9.354 L/ha
        if (!isNaN(value)) {
            return value * 9.354;
        } else {
            return 0;
        }
    }
    lph_to_galph = (value) => {// 1L/ha = 0,264172 gal/acre
        if (!isNaN(value)) {
            return value / 3.78541;
        } else {
            return 0;
        }
    }
    c_to_f = (value) => {// 1C = 9/5F + 32
        if (!isNaN(value)) {
            return (value * 9 / 5) + 32;
        } else {
            return 0;
        }
    }
    f_to_c = (value) => {// 1F = 5/9(C - 32)
        if (!isNaN(value)) {
            return (value - 32) * 5 / 9;
        } else {
            return 0;
        }
    }
    hah_to_ach = (value) => {// 1ha/h = 2.47105 ac/h
        if (!isNaN(value)) {
            return value * 2.47105;
        } else {
            return 0;
        }
    }
    ham_to_acm = (value) => {// 1ha/m = 2.47105 ac/m
        if (!isNaN(value)) {
            return value * 2.47105;
        } else {
            return 0;
        }
    }
    psi_to_bar = (value) => {// 1psi = 0.0689476 bar
        if (!isNaN(value)) {
            return value * 0.0689476;
        } else {
            return 0;
        }
    }
    bar_to_psi = (value) => {// 1bar = 14.5038 psi
        if (!isNaN(value)) {
            return value * 14.5038;
        } else {
            return 0;
        }
    }
    mm_to_in = (value) => {// 1mm = 0.0393701 inch  
        if (!isNaN(value)) {
            return value / 25.4;
        } else {
            return 0;
        }
    }
    mps_to_fts = (value) => {// 1m/s = 3.28084 ft/s
        if (!isNaN(value)) {
            return value * 3.28084;
        } else {
            return 0;
        }
    }
    kmh_to_mps = (value) => {// 1km/h = 0.277778 m/s
        if (!isNaN(value)) {
            return value / 3.6;
        } else {
            return 0;
        }
    }
    mph_to_kmh = (value) => {// 1mph = 1.60934 km/h
        if (!isNaN(value)) {
            return value * 1.60934;
        } else {
            return 0;
        }
    }
    fts_to_mps = (value) => {// 1ft/s = 0.3048 m/s
        if (!isNaN(value)) {
            return value * 0.3048;
        } else {
            return 0;
        }
    }
    mph_to_fts = (value) => {// 1mph = 1.46667 ft/s
        if (!isNaN(value)) {
            return value * 1.46667;
        } else {
            return 0;
        }
    }
    fts_to_mph = (value) => {// 1ft/s = 0.681818 mph
        if (!isNaN(value)) {
            return value / 1.46667;
        } else {
            return 0;
        }
    }
    m2_to_ac = (value) => {// 1m2 = 0.000247105 acre
        if (!isNaN(value)) {
            return value / 4046.86;
        } else {
            return 0;
        }
    }
    m2_to_ha = (value) => {// 1m2 = 0.0001 ha
        if (!isNaN(value)) {
            return value / 10000;
        } else {
            return 0;
        }
    }

    kmh_to_kt = (value) => {// 1km/h = 0.539957 kt
        if (!isNaN(value)) {
            return value / 1.852;
        } else {
            return 0;
        }
    };

    kt_to_kmh = (value) => {// 1kt = 1.852 km/h
        if (!isNaN(value)) {
            return value * 1.852;
        } else {
            return 0;
        }
    };

    l_to_gal_uk = (value) => {// 1L = 0.219969 gal(UK)
        if (!isNaN(value)) {
            return value / 4.54609;
        } else {
            return 0;
        }
    };

    gal_uk_to_l = (value) => {// 1gal(UK) = 4.54609 L
        if (!isNaN(value)) {
            return value * 4.54609;
        } else {
            return 0;
        }
    };

    ac_to_ha = (value) => {// 1ac = 0.404686 ha
        if (!isNaN(value)) {
            return value / 2.47105;
        } else {
            return 0;
        }
    };

    round = (value, decimal) => {// Round a number to a specific decimal place
        if (value === undefined || value === null || isNaN(value)) {
            return 0;
        }

        return Number(Math.round(value + 'e' + decimal) + 'e-' + decimal);
    }
}

const tools = new Tools();

export default tools;
